import { Diagnosis, TreatPatientAllergy, TreatPatientMedication, TreatPatientMedicationSelfReported } from '@uplift/types';
import { restClient } from '../../client';
import { PatientMeasurement, MedicalCondition } from '../../resources/patient';
import snakecaseKeys from 'snakecase-keys';


export const getPatientDiagnosis = async (userId: string) =>
  restClient.request<{ data: Diagnosis[] }>(`/api/v1/patient/${userId}/diagnosis`);

export const getPatientFamilyHistory = async (userId: string) =>
  restClient.request<{ data: string[] }>(`/api/v1/patient/${userId}/family_history`);

export type GetPatientMedicationResponse = {
  data: {
    rxorders: TreatPatientMedication[];
    homemeds: TreatPatientMedicationSelfReported[];
  };
};

export const getMedicalConditions = () => restClient.request<{ data: MedicalCondition[] }>('/api/v1/medical_conditions');

export const getPatientMedicalConditions = async (patientId: string) =>
  restClient.request<{
    data: MedicalCondition[];
  }>(`/api/v1/patient/${patientId}/medical_conditions`);

export const updatePatientMedicalConditions = async (userId: string, medicalConditions: (readonly [string, string])[]) =>
  restClient.request(`/api/v1/patient/${userId}/medical_conditions`, { method: 'POST', data: { medical_conditions: medicalConditions } });

export const getPatientMedication = async (userId: string) =>
  restClient.request<GetPatientMedicationResponse>(`/api/v1/patient/${userId}/medication`);

export const updatePatientMedications = async (userId: string, drugNames: string[]) =>
  restClient.request(`/api/v1/patient/${userId}/medication`, { method: 'POST', data: { drug_names: drugNames } });

export const getPatientAllergies = async (userId: string) =>
  restClient.request<{ data: TreatPatientAllergy[] }>(`/api/v1/patient/${userId}/allergies`);

export const updatePatientAllergies = async (userId: string, allergyNames: string[]) =>
  restClient.request(`/api/v1/patient/${userId}/allergies`, { method: 'POST', data: { allergy_names: allergyNames } });

export const getPatientMeasurements = (userId: string, includeArchived = false) =>
  restClient.request<{ data: PatientMeasurement[] }>(`/api/v1/patient/${userId}/measurement`, { params: snakecaseKeys({ includeArchived }) });

export type CreatePatientMeasurement = Partial<Pick<PatientMeasurement, 'heightInches' | 'weightLbs'>>;

export const setPatientMeasurement = (userId: string, data: CreatePatientMeasurement) =>
  restClient.request(`/api/v1/patient/${userId}/measurement`, { method: 'POST', data: snakecaseKeys(data) });

export type ClientChartRequest = {
  kind: 'all' | 'just' | 'provider' | 'date' | 'date_span';
  psychiatry: boolean;
  therapy: boolean;
  other: boolean;
  prescriptionOrders?: boolean;
  providerId?: string;
  onlyDate?: string;
  onlyNote?: string;
  dateFrom?: string;
  dateTo?: string;
};

export const getPatientChartPDF = (patientId: string, req: ClientChartRequest) =>
  restClient.fileRequest<Blob>(`/api/v1/pdf/generate/patient_chart/${patientId}`, {
    responseType: 'blob',
    params: snakecaseKeys(req)
  });
